"use strict";

import Dom from "common/Dom";
import * as handlers from "./handlers";
export const bindActions = function bindActions() {
  handlers.initLazyLoad();
  handlers.initLazyBackground();
};
